__turbopack_context__.v({
  "loading-animation": "HMmcPG_loading-animation",
  "loading-container": "HMmcPG_loading-container",
  "loading-message": "HMmcPG_loading-message",
});
